import React from 'react'

export const TopListItem = ({ item, last }) => (
  <li className={`list-item col-lg-6 border-top border-left border-right py-3 px-6 d-flex align-items-center ${last && "border-bottom"}`}>
    <i className="fas fa-times text-danger mr-2" />
    <strong>{item}</strong>
  </li>
)
